import { PARTNER } from 'components/_Assets/svg/PressLogo/partner'
import Footer from 'components/Footer'
import * as React from 'react'
import { DefaultContent, DisplayContent } from 'react-content-engine'
import { connect } from 'react-redux'
import { getCdnUrl } from '../../data/api/cdn'
import { Theme } from '../../data/models/funnelOrder/theme'
import { PerCountry, SiteCountry } from '../../data/models/locale'
import { AppState } from '../../data/state'
import IfCountry from '../../elements/conditionals/IfCountry'
import { Slink } from '../../routing/links'

export interface NormalFooter {
  alternative?: boolean
}
export interface NormalFooterProps extends NormalFooter {
  theme: Theme
  country: SiteCountry
  alternative?: boolean
}

const NormalFooter: React.FC<NormalFooterProps> = ({
  country,
  theme,
  alternative = false,
}) => {
  const facebookTravellersUrlbyCountry: PerCountry<string> = {
    nl: 'https://www.facebook.com/groups/srprsme/about/',
    be: 'https://www.facebook.com/groups/srprsme.be/about/',
    uk: 'https://www.facebook.com/groups/srprsme.uk/about/',
    ie: 'https://www.facebook.com/groups/srprsme.uk/about/',
    dk: 'https://www.facebook.com/groups/srprsme.uk/about/',
  }

  const pressUrlByCountry: PerCountry<string> = {
    nl: 'https://srprsme.pr.co/',
    be: 'https://srprsme.ambassy.be/srprsme',
    uk: 'https://rooster.co.uk/#News',
    ie: 'https://rooster.co.uk/#News',
    dk: 'https://www.9pr.dk',
  }

  const phoneByCountry: PerCountry<string> = {
    nl: '+31 (0)20 26 11 737',
    be: '+32 (0)38 087 098',
    uk: '+44 (0)20 8068 4521',
    ie: '+44 (0)20 8068 4521',
    dk: '+45 89 88 44 17',
  }

  const facebookUrlByCountry: PerCountry<string> = {
    be: '//facebook.com/srprsmeBE',
    dk: '//facebook.com/srprsmeDK',
    ie: '//facebook.com/srprsme',
    nl: '//facebook.com/srprsme',
    uk: '//facebook.com/srprsme',
  }

  const facebookUrl = facebookUrlByCountry[country]
  const phoneNumber = phoneByCountry[country]
  const isFlyTheme = theme === Theme.fly
  const facebookTravellersUrl = facebookTravellersUrlbyCountry[country]
  const pressUrl = pressUrlByCountry[country]

  return (
    <Footer
      alternative={alternative}
      facebookUrl={facebookUrl}
      available
      phoneNumber={phoneNumber}
      srprsmeLinks={
        <>
          <li>
            <Slink name="about">
              <DefaultContent contentKey="about-us">About</DefaultContent>
            </Slink>
          </li>
          <li>
            <Slink name="how">
              <DefaultContent contentKey="how-works">
                How it works
              </DefaultContent>
            </Slink>
          </li>
          <li>
            {isFlyTheme ? (
              <Slink name="flycustomise">
                <DisplayContent edit={true} contentKey="book-trip">
                  Book a trip
                </DisplayContent>
              </Slink>
            ) : (
              <Slink name="drivecustomise">
                <DisplayContent edit={true} contentKey="book-trip">
                  Book a trip
                </DisplayContent>
              </Slink>
            )}
          </li>
          <li>
            <Slink name="gift">
              <DisplayContent edit={true} contentKey="gift-card">
                Gift card
              </DisplayContent>
            </Slink>
          </li>
          <li>
            <a target="_blank" href={facebookTravellersUrl}>
              Facebook Travellers
            </a>
          </li>
        </>
      }
      infoLinks={
        <>
          <li>
            <Slink name="service">
              <DisplayContent edit={true} contentKey="faq">
                FAQ
              </DisplayContent>
            </Slink>
          </li>
          <li>
            <Slink name="service">
              <DefaultContent contentKey="contact-support">
                Contact &amp; Support
              </DefaultContent>
            </Slink>
          </li>
          <li>
            <a target="_blank" href={pressUrl}>
              <DisplayContent edit={true} contentKey="press">
                Press
              </DisplayContent>
            </a>
          </li>
          <li>
            <Slink name="conditions">
              <DisplayContent contentKey="terms-and-conditions">
                Terms &amp; Conditions
              </DisplayContent>
            </Slink>
          </li>
          <IfCountry country={[SiteCountry.nl, SiteCountry.be]}>
            <li>
              <a target="_blank" href={getCdnUrl('privacypolicy-nl.pdf')}>
                <DisplayContent edit={true} contentKey="privacy_policy">
                  Privacy policy
                </DisplayContent>
              </a>
            </li>
          </IfCountry>
          <IfCountry country={[SiteCountry.uk, SiteCountry.ie, SiteCountry.dk]}>
            <li>
              <Slink name="privacy">
                <DisplayContent edit={true} contentKey="privacy">
                  Privacy
                </DisplayContent>
              </Slink>
            </li>
          </IfCountry>
        </>
      }
      icons={
        <>
          <IfCountry country={[SiteCountry.nl, SiteCountry.be]}>
            <a href="https://www.anvr.nl/anvrleden/Certificaat.aspx?nummer=5403">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 192.756 192.756"
              >
                {PARTNER.anvr}
              </svg>
            </a>
          </IfCountry>
          <IfCountry country={[SiteCountry.uk, SiteCountry.ie, SiteCountry.dk]}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 192.756 192.756"
            >
              {PARTNER.anvr}
            </svg>
          </IfCountry>
          <IfCountry country={SiteCountry.nl}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 192.756 192.756"
            >
              {PARTNER.calamiteitenfonds}
            </svg>
          </IfCountry>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192.756 192.756">
            {PARTNER.sgr}
          </svg>
        </>
      }
    />
  )
}

export default connect((state: AppState) => ({
  theme: state.funnelOrder.theme,
  country: state.locale.country,
}))(NormalFooter)
